import {FilterRenderer} from "./Filters";
import {useCatalog} from "../../store/catalog";

export function FilterPanel() {
    const {stagedFilterValues, stageFilterValue, filterConfigs} = useCatalog();

    if (!filterConfigs.length) {
        return null;
    }

    return (
        <div className="space-y-2">
            {filterConfigs.filter(config => !config.hidden).map(config => (
                <details
                    key={config.id}
                    open
                    className="pt-filter-collapse group border-b border-base-200 last:border-b-0"
                >
                    <summary className="pt-filter-section-title flex items-center justify-between py-4 cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                        <span>{config.label}</span>
                        <svg
                            className="w-4 h-4 transition-transform duration-200 group-open:rotate-180"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                    </summary>
                    <div className="pb-4">
                        <FilterRenderer
                            config={config}
                            value={stagedFilterValues[config.id]}
                            onChange={value => stageFilterValue(config.id, value)}
                        />
                    </div>
                </details>
            ))}
        </div>
    );
}